module.exports = __webpack_public_path__ + "img/style_guide_bg_m.4ddec2d0.png";